export default function animateIn() {
  const controller = new ScrollMagic.Controller();
  const elements = document.querySelectorAll('.fade-in-container');

  for (let i = 0; i < elements.length; i++) {
    const el = elements[i];
    const sceneOptions = {
      triggerElement: el,
      triggerHook: 0.5,
      reverse: false,
    };

    new ScrollMagic.Scene(sceneOptions)
    .setClassToggle(el, 'animate-in')
    .addTo(controller);
  }

  return this;
}



// WEBPACK FOOTER //
// ./library/js/modules/animate-in.js